export const meta = {
  id: 'longest-palindromic-subsequence',
  name: 'Longest Palindromic Subsequence',
  category: 'DP',
  complexity: {
    time: 'O(n²)',
    space: 'O(n²)'
  },
  description: 'Longest Palindromic Subsequence finds the longest subsequence that reads the same forwards and backwards using dynamic programming.'
};
